var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 500'%3e%3cpath fill='%234AADD6' d='M0 0h800v500H0z'/%3e%3ccircle fill='%23FFDE00' cx='350' cy='250' r='150'/%3e%3c/svg%3e";
  export default img;